<script setup>
import VideoPlayer from '../../../VideoPlayer.vue'
import JOETransition4 from '../../../../assets/animations/joe/transitions/joe_transition_4_sped_up.webm'
import { onMounted, onUnmounted } from 'vue'

const { manualStart, direction } = defineProps({
  manualStart: {
    type: Boolean,
    default: false,
  },
  direction: {
    type: String,
    default: 'in',
  },
})

const videoElement = ref(null)

const showSlot = ref(direction === 'out')

const videoFullyCoversScreenAtSecond = 21 / 50

onMounted(() => {
  if (!manualStart) {
    start()
  }
})

let rafId = null
const onFrame = () => {
  if (videoElement.value.currentTime >= videoFullyCoversScreenAtSecond) {
    showSlot.value = direction === 'in'
    return
  }
  rafId = requestAnimationFrame(onFrame)
}

const start = async () => {
  videoElement.value.play()
  rafId = requestAnimationFrame(onFrame)

  return new Promise((resolve) => {
    videoElement.value.onended = () => {
      resolve()
    }
  })
}
defineExpose({ start })

onUnmounted(() => {
  if (rafId) {
    cancelAnimationFrame(rafId)
  }
})
</script>

<template>
  <div class="size-full" :data-transition-direction="direction">
    <VideoPlayer :src="JOETransition4" muted class="absolute z-20" @videoElement="videoElement = $event" />
    <div v-show="showSlot" class="size-full">
      <slot />
    </div>
  </div>
</template>
